import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PlaceRecommendCard from './components/PlaceRecommendCard'
import { compose } from '@hocs'

class PlaceRecommendsContainer extends PureComponent {
  render() {
    const { ownPlaceId, place, loc } = this.props
    return (
      <div>
        <PlaceRecommendCard ownPlaceId={ownPlaceId} data={place} loc={loc} />
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ownPlaceId: state.place.get('placeId'),
    place: state.place.getIn(['places', ownProps.placeId]),
    loc: state.currentUser.get('userLocation'),
  }
}

export default compose(connect(mapStateToProps))(PlaceRecommendsContainer)
